import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consudoc/list", params, successCallback, failCallback, exceptionCallback);
	}, 
	merge : (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consudoc/merge", params, successCallback, failCallback, exceptionCallback);
	} ,leadTo: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consudoc/leadTo", params, successCallback, failCallback, exceptionCallback);
	} 
}

export default api;
